import React from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

import { useModal } from '../Modal/ModalContext';

import { formatNull, formatDate, isDatePastInMoscow, formatOverflow } from '../../Utils/GlobalUtils';

import LoadingLines from '../LoadingLines';

import styles from '../../styles/DynamicModal.module.css';
import stylesSearch from '../../styles/Search.module.css';

import IconContainer from '../../Components/IconContainer';
import { ReactComponent as XIcon } from '../../icons/x-close.svg';

const SearchProposedCases = ({ closeModal, type }) => {
    const { openModal } = useModal();
    const navigate = useNavigate();
    const location = useLocation();

    const [cases, setCases] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [warning, setWarning] = React.useState('');

    const inputRef = React.useRef(null);

    React.useEffect(() => {
        inputRef.current?.focus();
    }, []);

    // React.useEffect(() => {
    //     const bannerShown = Cookies.get('bannerTDltSearchWelcome');        
    //     const bannerTDltSearchWelcome = 
    //     <form>
    //         <h3 style={{marginBottom: '15px', width: '100%'}}>Добро пожаловать в поиск.</h3>
    //         <a>Поиск происходит по заданному типу дел.</a>
    //         <a>Тип определяется от страницы, на которой открыт поиск.</a>
    //         <a style={{color: '#7c7c7c', marginBottom: '20px'}}>Например, если поисковое окно открыто из страницы "Назначения", то поиск происходит по делам с типом "Назначение".</a>
    //         <a>При нахождении записи, вы можете нажать на неё и откроется новая вкладка с подробной карточкой дела.</a>
    //         <a>Вы всегда можете вернуться к поиску. Для этого просто перейдите назад на эту страницу в браузере.</a>
    //     </form>;
    //     if (!bannerShown) {
    //         // Если баннер еще не был показан, показываем его
    //         openModal('Ознакомление с системой', bannerTDltSearchWelcome);
            
    //         // Устанавливаем куки, чтобы отметить, что баннер был показан
    //         Cookies.set('bannerTDltSearchWelcome', 'true', { expires: 365 }); // Куки будет храниться 1 год
    //     }
    // }, []);

    

    const handleLogout = () => {
        localStorage.removeItem('token');
        window.location.href = '/';
    }

    const [searchTerm, setSearchTerm] = React.useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = React.useState('');

    React.useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500); // задержка 500 мс

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        if (!token) handleLogout();
        if (debouncedSearchTerm.trim() == '') {
            setWarning('Введите поисковый запрос');
        } else {
            setLoading(true);

            axios.get(`/api/search-proposed-cases?searchterm=${debouncedSearchTerm}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            .then((response) => {
                if (response.data.length === 0) {
                    setCases([]);
                    setWarning('Ничего не найдено');
                } else {
                    setCases(response.data);
                    setWarning('');
                }
            })
            .catch((error) => {
                console.error(error);
                setWarning(`${error.response?.data.message || 'Произошла неизвестная ошибка. Попробуйте повторить позднее'}`);
            })
            .finally(() => {
                setLoading(false);
            })
        }
    }, [debouncedSearchTerm]);


    return (
        <div className={styles.liningOver}>
            <motion.div
                className={styles.lining} 
                onClick={(e) => e.stopPropagation()}
                initial={{ scale: '97%', opacity: 0 }}
                animate={{ scale: '100%', opacity: 1 }}
                exit={{ scale: '97%', opacity: 0 }}
                transition={{ duration: 0.3 }}
            >
                <div className={styles.header}>
                    <h1>Поиск по витрине заявок</h1>
                    <IconContainer Icon={XIcon} onClick={closeModal} size = '20' color = 'black' className = '' />
                </div>
                <div className={styles.main} style={{height: '80vh'}}>
                    <div className={stylesSearch.searchInputWrapper}>
                        <input type='text' value={searchTerm} onChange={(e) => {setSearchTerm(e.target.value)}} placeholder='Номер дела, номер вх. корреспонденции или должник...' ref={inputRef} />
                    </div>
                    <div className={stylesSearch.mainWrapper}>
                        {loading ? <LoadingLines />
                        : warning ? <a className={`description ${stylesSearch.centerWarning}`}>{warning}</a>
                        : <>
                            <a className='description'>Первые 10 совпадений</a>
                            <div
                                className='tableRow nonActive' 
                                style={{gridTemplateColumns: '20fr 40fr 40fr'}} 
                            >
                                <div>
                                    Номер
                                </div>
                                <div>
                                    Должники
                                </div>
                                <div>
                                    Статус заявки
                                </div>
                            </div>
                            {cases.map(caseItem => (
                                <motion.div
                                    className='tableRow'
                                    style={{gridTemplateColumns: '20fr 40fr 40fr'}}
                                    onClick={() => {navigate(`/case/${caseItem.id}`, { state: { from: location.pathname + location.search + location.hash }})}}
                                    key={caseItem.id}
                                    initial={{ scale: '97%', opacity: 0 }}
                                    animate={{ scale: '100%', opacity: 1 }}
                                    exit={{ scale: '97%', opacity: 0 }}
                                    transition={{ duration: 0.3 }}
                                    layout
                                >
                                    <div>
                                        {formatNull(caseItem.number)}
                                        <a className='description'>{formatNull(caseItem.internal_number)}</a>
                                        {cases.to_case_number && 'Жалоба на: '+caseItem.to_case_number}
                                    </div>
                                    <div>
                                        <p>
                                            {caseItem.debtors ?
                                                <p>
                                                    {formatOverflow(caseItem.debtors.map((e) => e.name).join(', '))}
                                                </p>
                                                :
                                                formatNull(caseItem.debtors)
                                            }
                                        </p>
                                    </div>
                                    <div>
                                        <p>
                                            АУ: {caseItem.user_id ? `${caseItem.lastname} ${caseItem.firstname} ${caseItem.surname} (${caseItem.email})`
                                        : 'Не выбран'
                                        }
                                        </p>
                                        <p >
                                            Рассылка проведена: {formatDate(caseItem.date_mailing)}
                                        </p>
                                        {!caseItem.user_id ?
                                        <p className={isDatePastInMoscow(caseItem.date_mailing_end) ? 'colorCell red' : ''}>
                                            Согласия ожидаются до: {formatDate(caseItem.date_mailing_end)} {isDatePastInMoscow(caseItem.date_mailing_end) ? '[Срок прошёл]' : ''}
                                        </p>
                                        : <></>}
                                    </div>
                                </motion.div>
                            ))}
                        </>
                        }
                    </div>
                </div>
            </motion.div>
        </div>
    );
};

export default SearchProposedCases;
